import { useAppSelector } from 'src/redux/hooks';
import { GlobalState } from 'src/redux/store';

export const salutationsSelector = (state: GlobalState) => state.salutations;

export const salutationsSelectorData = (state: GlobalState) => salutationsSelector(state).data;

export const useSalutations = () => useAppSelector(salutationsSelectorData);
